import webApi, { baseURL } from "../../WebApi/WebApi";

//VAT ADD
export const getQualityContorl = async (text,  onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/qualityControl/add-quality-control`, {
                text: text,


        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
};


//LIST OF QUALITY CONTROL
export const getAllQuallityControllist = async (data) => {
    return await webApi.get(`/customer/qualityControl/list-quality-control`,
    );
}


//DELETE Quality control
export const deleteQualityControl= async (qualityControlId, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/qualityControl/delete-quality-control`, {
                qualityControlId: qualityControlId,

        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
};